window.initMap = function(){

    //Markers
    var markers = [];

    var name = document.getElementById('map').dataset.name;
    var address = document.getElementById('map').dataset.address;
    var lat = document.getElementById('map').dataset.lat;
    var lng = document.getElementById('map').dataset.lng;

    //Map config
    var center = {lat: parseFloat(lat), lng: parseFloat(lng)};
    var zoom = 13;

    var map = new google.maps.Map(document.getElementById('map'), {
        center: center,
        zoom: zoom,
        disableDefaultUI: true, // a way to quickly hide all controls,
        streetViewControl: true,
        scaleControl: true,
        zoomControl: true,
        styles: [
            {
                "featureType": "administrative.locality",
                "elementType": "all",
                "stylers": [
                    {
                        "lightness": "0"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "lightness": "100"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "hue": "#f3f4f4"
                    },
                    {
                        "saturation": -84
                    },
                    {
                        "lightness": 59
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels",
                "stylers": [
                    {
                        "hue": "#ff0000"
                    },
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": "100"
                    },
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape.natural",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.attraction",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.business",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.government",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.medical",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "hue": "#adff00"
                    },
                    {
                        "saturation": "0"
                    },
                    {
                        "lightness": "-9"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi.place_of_worship",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.school",
                "elementType": "all",
                "stylers": [
                    {
                        "hue": "#00ffff"
                    },
                    {
                        "saturation": -60
                    },
                    {
                        "lightness": 23
                    },
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.sports_complex",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "lightness": "0"
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "hue": "#ff0000"
                    },
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 100
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels",
                "stylers": [
                    {
                        "hue": "#ff0000"
                    },
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 26
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {
                        "hue": "#ffcc00"
                    },
                    {
                        "saturation": 100
                    },
                    {
                        "lightness": "-10"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.highway.controlled_access",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "hue": "#ffcc00"
                    },
                    {
                        "saturation": 100
                    },
                    {
                        "lightness": "-15"
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "all",
                "stylers": [
                    {
                        "lightness": "0"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "hue": "#00b5ff"
                    },
                    {
                        "saturation": 55
                    },
                    {
                        "lightness": -6
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                    {
                        "hue": "#7fc8ed"
                    },
                    {
                        "saturation": 55
                    },
                    {
                        "lightness": -6
                    },
                    {
                        "visibility": "off"
                    }
                ]
            }
        ]
    });

    //Populate map
    var marker = new google.maps.Marker({
        position: {lat: parseFloat(lat), lng: parseFloat(lng)},
        map: map,
        icon: '../../themes/LBIMainSite/static/img/marker.png',
        title: name
    });
    markers.push(marker);

    var content = '';

    if(window.matchMedia("(max-width:720px)").matches){
        content = '<div class="infowindow">'+
            '<i class="icon-close" id="close-info"></i>'+
            '<p class="infowindow__title">'+name+'</p>'+
            '<div class="infowindow__address"><i class="icon-place"></i>'+address+'</div>'+
            '<div class="infowindow__cta"><div class="infowindow__cta--itineraire"><a href="https://www.google.com/maps/dir/?api=1&destination='+lat+','+lng+'" target="_blank" class=""><i class="icon-direction"></i>Itinéraire</a></div></div>'+
            '</div>';
    }else{
        content = '<div class="infowindow">'+
            '<p class="infowindow__title">'+name+'</p>'+
            '<div class="infowindow__address"><i class="icon-place"></i>'+address+'</div>'+
            '<div class="infowindow__cta"><div class="infowindow__cta--itineraire"><a href="https://www.google.com/maps/dir/?api=1&destination='+lat+','+lng+'" target="_blank" class=""><i class="icon-direction"></i>Itinéraire</a></div></div>'+
            '</div>';
    }

    var infoWindow = new google.maps.InfoWindow();

    var flag = false;

    google.maps.event.addListener(marker,'click', (function(marker,content,infoWindow){
        return function() {
            if(!flag){
                marker.setIcon('../../themes/LBIMainSite/static/img/bigmarker.png');
                flag = true;
                infoWindow.setContent(content);
                infoWindow.open(map,marker);
            }
            else{
                infoWindow.close(map,marker);
                marker.setIcon('../../themes/LBIMainSite/static/img/marker.png');
                flag = false;
            }
        };
    })(marker,content,infoWindow));

    google.maps.event.addListener(map,'click', (function(marker, infoWindow){
        return function() {
            if(window.matchMedia("(max-width:720px)").matches){
                document.querySelector('.infowindow--mobile').style.opacity = 0;
                document.querySelector('.infowindow--mobile').innerHTML = '';
                marker.setIcon('../../themes/LBIMainSite/static/img/marker.png');
                flag = false;
            }else{
                infoWindow.close(map,marker);
                marker.setIcon('../../themes/LBIMainSite/static/img/marker.png');
                flag = false;
            }
        };
    })(marker, infoWindow));

    google.maps.event.addListener(infoWindow,'closeclick', (function(marker,content,infoWindow){
        return function() {
            marker.setIcon('../../themes/LBIMainSite/static/img/marker.png');
            flag = false;
        };
    })(marker,content,infoWindow));
};
